import { SCREENS } from '@core/assistant/interfaces';
import { debugTagName } from '@core/assistant/constants';

export const globals = {
  visualizerInstance: undefined as any,
  activeScreenGlob: SCREENS.DEFAULT as SCREENS,
  isMutedGlob: false,
  currentRegion: '',
  assistantGain: 1,
  assistantPlaybackRate: 1,
  // Module-level (not component state) so the one-time landing greet survives
  // the assistant Button being unmounted/remounted — e.g. HomeBottomBar moves
  // it between JSX slots when isHideAllExceptTopBar toggles, which would
  // otherwise reset a local ref and let a later `scripts` refetch replay it.
  hasGreetedLandingGlob: false,
};

export const getCurrentRegion = (): string => {
  let currentArea = globals.currentRegion;
  if (!globals.currentRegion && debugTagName) {
    currentArea = debugTagName;
  }
  return currentArea;
};
